import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import CloudflareImage from '../components/ui/cloudflare-image';
import { getSettings, getLeaderboard } from '../services/publicService';
import { useAuth } from '../context/AuthContext';

const PageContainer = styled.div`
  width: 100%;
  padding: 0;
`;

const NavbarSpacer = styled.div`
  height: 120px;
  
  @media (min-width: 768px) {
    height: 140px;
  }
  
  @media (min-width: 1024px) {
    height: 160px;
  }
`;

const ContentContainer = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
  
  @media (min-width: 1536px) {
    max-width: 1600px;
  }
  
  @media (min-width: 768px) {
    padding: 0 5%;
  }
  
  @media (min-width: 1024px) {
    padding: 0 10px;
  }
`;

const TabsWrapper = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  max-width: 100%;
  
  @media (min-width: 1024px) {
    padding-bottom: 2rem;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
  
  @media (min-width: 1024px) {
    gap: 1rem;
  }
`;

const Tab = styled(Link)`
  font-weight: 300;
  background-color: ${props => props.active ? '#7a7a7a' : '#e9e9e9'};
  padding: 0.5rem 1.25rem;
  min-width: 150px;
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  text-align: center;
  text-decoration: none;
  color: ${props => props.active ? '#fff' : '#000'};
`;

const LeaderboardCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  color: white;
  margin-bottom: 2.5rem;
  border-radius: 0.75rem;
  background: #121212;
  
  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 2.5rem;
    background: linear-gradient(to right, #121212 30%, #121212 70%, #646155);
  }
`;

const LeftSection = styled.div`
  width: 100%;
  
  @media (min-width: 1024px) {
    width: calc(50% - 1px);
    border-right: 1px solid #2b2b2b;
    padding-right: 2rem;
  }
`;

const RightSection = styled.div`
  width: 100%;
  
  @media (min-width: 1024px) {
    width: calc(50% - 1px);
    padding-left: 2rem;
  }
`;

const LeaderboardHeader = styled.div`
  margin-bottom: 2rem;
`;

const HeaderContent = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

const LeaderboardIcon = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LeaderboardTitle = styled.div`
  color: #b1a797;
  font-size: 1.125rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
`;

const LeadersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem 3.75rem;
  
  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media (min-width: 1024px) {
    grid-template-rows: repeat(3, auto);
    grid-template-columns: 1fr 1fr;
  }
`;

const LeaderItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1.75rem;
`;

const LeaderAvatar = styled.div`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LeaderInfo = styled.div``;

const LeaderName = styled.div`
  color: #b1a797;
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const LeaderPoints = styled.div`
  color: white;
  font-size: 1rem;
`;

const VerticalDivider = styled.div`
  display: none;
  
  @media (min-width: 1024px) {
    display: block;
    height: 66.666667%;
    margin: auto 1.25rem;
    width: 1px;
    background-color: #474747;
  }
`;

const HorizontalDivider = styled.div`
  height: 1px;
  width: 100%;
  margin: 1.25rem auto;
  background-color: #474747;
  
  @media (min-width: 1024px) {
    display: none;
  }
`;

const InfoPanel = styled.div`
  padding: 1.5rem 0;
  
  @media (min-width: 1024px) {
    padding: 1.5rem 0;
  }
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.75rem;
  margin-bottom: 1.25rem;
`;

const ProfileInfo = styled.div``;

const ProfileName = styled.div`
  color: #b1a797;
  font-size: 1.125rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const ProfilePoints = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const PointsValue = styled.div`
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
`;

const CrownIcon = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    fill: white;
    width: 25px;
    height: 25px;
  }
`;

const InfoText = styled.div`
  font-weight: 300;
  
  div {
    margin-bottom: 1rem;
  }
`;

const LeaderboardPage = () => {
  const { user } = useAuth();
  const [staticLeaders, setStaticLeaders] = useState([]);
  const [topUsers, setTopUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userCoins, setUserCoins] = useState(0);
  
  const tabs = [
    { id: 'market', name: 'MARKET', path: '/market' },
    { id: 'leaderboard', name: 'LEADERBOARD', path: '/leaderboard' },
    { id: 'auctions', name: 'TMZ AUCTIONS', path: '/auctions' },
    { id: 'spotted', name: 'SPOTTED', path: '/spotted' },
    { id: 'irl', name: 'IRL', path: '/irl' },
    { id: 'recruit', name: 'RECRUIT', path: '/recruit' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch static leaders from settings
        const settingsResponse = await getSettings();
        if (settingsResponse.success && settingsResponse.settings?.leaderboard?.staticLeaders) {
          setStaticLeaders(settingsResponse.settings.leaderboard.staticLeaders);
        }
        
        // Fetch top users
        const leaderboardResponse = await getLeaderboard(5);
        if (leaderboardResponse.success) {
          setTopUsers(leaderboardResponse.users);
        }
        
        // Calculate user's coin balance if logged in
        if (user?.madCoins?.transactions) {
          const balance = user.madCoins.transactions.reduce((acc, transaction) => {
            if (transaction.type === 'credit') {
              return acc + transaction.amount;
            } else if (transaction.type === 'debit') {
              return acc - transaction.amount;
            }
            return acc;
          }, 0);
          setUserCoins(Math.round(balance));
        }
      } catch (error) {
        console.error('Error fetching leaderboard data:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [user]);

  return (
    <PageContainer>
      <NavbarSpacer />
      <ContentContainer>
        <TabsWrapper>
          <TabsContainer>
            {tabs.map(tab => (
              <Tab 
                key={tab.id} 
                to={tab.path} 
                active={tab.id === 'leaderboard' ? 1 : 0}
              >
                {tab.name}
              </Tab>
            ))}
          </TabsContainer>
        </TabsWrapper>
        
        <LeaderboardCard>
          <LeftSection>
            <LeaderboardHeader>
              <HeaderContent>
                <LeaderboardIcon>
                  <CloudflareImage src="/images/madicon.png" alt="TheMadZone Coin" />
                </LeaderboardIcon>
                <LeaderboardTitle>
                  {staticLeaders.length > 0 ? 'STATIC LEADERS' : 'TOP LEADERS'}
                </LeaderboardTitle>
              </HeaderContent>
            </LeaderboardHeader>
            
            <LeadersGrid>
              {loading ? (
                <div style={{ color: '#b1a797' }}>Loading...</div>
              ) : staticLeaders.length > 0 ? (
                staticLeaders.map((leader, index) => (
                  <LeaderItem key={index}>
                    <LeaderAvatar>
                      <CloudflareImage src="/images/avatar.svg" alt="Avatar" />
                    </LeaderAvatar>
                    <LeaderInfo>
                      <LeaderName>{leader.name}</LeaderName>
                      <LeaderPoints>{leader.coins.toLocaleString()}</LeaderPoints>
                    </LeaderInfo>
                  </LeaderItem>
                ))
              ) : topUsers.length > 0 ? (
                topUsers.slice(0, 5).map((user, index) => (
                  <LeaderItem key={user._id}>
                    <LeaderAvatar>
                      <CloudflareImage src="/images/avatar.svg" alt="Avatar" />
                    </LeaderAvatar>
                    <LeaderInfo>
                      <LeaderName>{user.firstName || user.email || 'User'}</LeaderName>
                      <LeaderPoints>{user.coinBalance?.toLocaleString() || 0}</LeaderPoints>
                    </LeaderInfo>
                  </LeaderItem>
                ))
              ) : (
                <div style={{ color: '#b1a797' }}>No leaders yet</div>
              )}
            </LeadersGrid>
          </LeftSection>
          
          <VerticalDivider />
          <HorizontalDivider />
          
          <RightSection>
            <InfoPanel>
              {user ? (
                <ProfileSection>
                  <LeaderAvatar>
                    <CloudflareImage src="/images/avatar.svg" alt="Avatar" />
                  </LeaderAvatar>
                  <ProfileInfo>
                    <ProfileName>{user.firstName || 'User'}</ProfileName>
                    <ProfilePoints>
                      <PointsValue>{userCoins.toLocaleString()}</PointsValue>
                      <CrownIcon>
                        <svg width="25" height="25" viewBox="0 0 59 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <path fill="#fff" d="M57.1,10.3c0.2-0.6,0.4-1.2,0.3-1.8c0,0.1-0.1,0.1-0.1,0.2l0-0.2L40.2,23.2c-0.3-0.8-0.5-1.5-0.8-2.3c-0.1-0.2-0.1-0.5-0.4-0.5c-0.3,0-0.1,0.4-0.4,0.6c-0.5-1.1-0.9-2.3-1.3-3.4c-0.3-0.8-0.4-1.9-1.1-2.4c-0.7-0.5-0.9-1-1.1-1.7c-0.1-0.7-0.3-1.3-0.4-2c-0.2-1.2-0.7-2.3-1.5-3.1c-0.9-1-1.5-2.1-1.9-3.4c-0.4-1.1-0.7-2.3-1.1-3.4c-0.1-0.2-0.2-0.5-0.4-0.6c0-0.1,0-0.2-0.1-0.4c-0.2,0.1-0.3,0.4-0.3,0.6c-0.1,0.4-0.2,0.8-0.3,1.1c-0.1,0.2,0,0.5-0.4,0.5c0,0-0.1,0.1-0.1,0.2c-0.1,0.5-0.2,1-0.4,1.4c-0.7,1.3-0.7,2.8-1.1,4.3l-0.6,1.9c-0.1-0.1,0-0.2-0.1-0.3c-0.2,0.1-0.1,0.2-0.2,0.4c-0.2,0.7-0.3,1.5-0.7,2.2c-0.1,0.1-0.1,0.3-0.3,0.3l-0.9,2.8c0,0,0-0.8-0.1-0.8c0,0.1-1.2,4.6-1.2,4.6l-0.9,1.9l0-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.3-0.2,0.8-0.2,1.3c0,0.2,0.1,0.2,0.3,0.2c0.1,0,0.2-0.1,0.3-0.1l0,0.1l1.2,1.2c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0-0.1l11.6,12.5l-13-11.1c0,0,0.1,0,0.1,0.1c-1.9-1.8-3.5-3.7-5.4-5.5c0,0-2.6-1.8-3.1-2c-0.3-0.2-0.6-0.3-0.8-0.4L13,18.3v0c0,0,0,0,0,0L1.9,8.8C1.8,8.6,1.7,8.4,1.6,8.2c0.8,3.9,2.9,7.5,3.4,11.5c-0.2,0.1-0.2-0.3-0.4-0.1c0.1,0.6,0.3,1.1,0.6,1.6c-0.2,0-0.3-0.3-0.5-0.2c0.1,0.3,0.1,0.6,0.2,0.9c0.6,1.8,1.4,3.5,2.1,5.2c1.2,3,2.6,5.9,2.8,9.1c0.2,0.1,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2l0,0l18.3,10.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.4-0.6,0.5c-0.4,0.3-0.9,0.7-1.4,1c0.1,0,0.2,0,0.2-0.1c0.7-0.4,1.5-0.7,2.2-1c0.5,0.4,0.9,0.8,1.6,1.1c0.2,0.1,0.5,0.2,0.7,0.4c0,0,0.1,0,0.1,0.1c0.4,0.2,0.7,0.5,1.1,0.7c-0.5-0.5-1-0.9-1.1-1.7c0.2-0.1,0.3,0.3,0.5,0.2c0.2-0.4-0.3-0.9-0.1-1.2c0.1-0.2,0.1-0.3,0.1-0.5l2.2-1.2c0.6-0.1,1.1-0.4,1.7-0.8c0.2-0.2,0.4-0.3,0.7-0.4c0,0-0.1,0-0.1,0c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.2-0.2,0.4-0.2c0.3-0.3,0.6-0.4,0.7-0.5c0.1-0.2,0.3-0.3,0.4-0.4L49.9,36l0,0c0,0,0,0,0,0c0.2-0.4,0.9-0.8,0.7-1.2c-0.4-0.6,0-0.9,0.2-1.3c0.3-0.8,0.6-1.5,1-2.5c-0.5,0.4-0.7,0.4-0.7,0.3l2-7.3c0.6-1.4,1.2-2.8,1.5-4.3c0.2-0.9,0.2-1.5,0.3-2.1l1.1-4.2C56.4,12.2,56.8,11.2,57.1,10.3z M17.4,21.7c1.5,1.3,3,2.6,4.3,4l-5.9-5C16.4,20.9,16.9,21.3,17.4,21.7z" />
                            <path fill="#fff" d="M36.6,13.9c0.2,1.9,1.3,3.9,2.1,6C38.8,18.9,37.3,14.6,36.6,13.9z" />
                            <path fill="#fff" d="M36.6,43.7C36.6,43.6,36.6,43.6,36.6,43.7C36.6,43.6,36.6,43.6,36.6,43.7z" />
                          </g>
                        </svg>
                      </CrownIcon>
                    </ProfilePoints>
                  </ProfileInfo>
                </ProfileSection>
              ) : (
                <ProfileSection>
                  <LeaderAvatar>
                    <CloudflareImage src="/images/avatar.svg" alt="Avatar" />
                  </LeaderAvatar>
                  <ProfileInfo>
                    <ProfileName>Guest</ProfileName>
                    <ProfilePoints>
                      <PointsValue>0</PointsValue>
                    </ProfilePoints>
                  </ProfileInfo>
                </ProfileSection>
              )}

              <InfoText>
                <div>
                  A new era, A new you, A new wave of Street Culture.
                  Your journey with TheMadZone comes with exclusive perks. Earn TheMadZone
                  Coins with every move you make, then turn them into a
                  currency of expression - gift cards, hot coupons, exclusive
                  event access, and future collections.
                </div>
                <div>
                  Keep an eye out on the score. The top 5 members who gain more coins will be displayed on the leadership board. You can be one too.
                </div>
              </InfoText>
            </InfoPanel>
          </RightSection>
        </LeaderboardCard>
      </ContentContainer>
    </PageContainer>
  );
};

export default LeaderboardPage; 